export default __webpack_public_path__ + "static/media/Reddit2.9378fad9.PNG";